// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/upper-winds.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/upper-winds/fb-interpolation.js';

mount([g0]);
